import React from "react";
import { Link } from "react-router-dom";
import { Eye } from "lucide-react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { LiveBadge } from "@/components/LiveBadge";

const fmtViewers = (n) =>
  n >= 1000 ? `${(n / 1000).toFixed(1)}k` : `${n}`;

export function LiveCard({ stream }) {
  return (
    <Link
      to={`/live/${stream.id}`}
      data-testid={`live-card-${stream.id}`}
      className="group block overflow-hidden rounded-2xl border border-border bg-card shadow-sm transition-transform duration-300 ease-in-out hover:-translate-y-1 hover:shadow-md"
    >
      <div className="relative aspect-video overflow-hidden">
        <img
          src={stream.thumbnail}
          alt={stream.title}
          loading="lazy"
          className="h-full w-full object-cover transition-transform duration-300 ease-in-out group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
        <div className="absolute left-3 top-3">
          <LiveBadge />
        </div>
        <div className="absolute right-3 top-3 flex items-center gap-1.5 rounded-full bg-black/55 px-2.5 py-1 text-xs font-semibold text-white backdrop-blur-md">
          <Eye className="h-3.5 w-3.5" />
          {fmtViewers(stream.viewers)}
        </div>
        <div className="absolute bottom-3 left-3 right-3 flex items-center gap-2">
          <Avatar className="h-8 w-8 border-2 border-white/80">
            <AvatarImage src={stream.host.avatar} alt={stream.host.displayName} />
            <AvatarFallback>{stream.host.displayName[0]}</AvatarFallback>
          </Avatar>
          <span className="truncate text-sm font-semibold text-white drop-shadow">
            {stream.host.displayName}
          </span>
        </div>
      </div>
      <div className="space-y-2 p-5">
        <h3 className="line-clamp-2 font-heading text-base font-bold leading-snug tracking-tight text-foreground">
          {stream.title}
        </h3>
        <p className="text-sm text-muted-foreground">
          {stream.category} · {stream.location.city}
        </p>
      </div>
    </Link>
  );
}

export default LiveCard;
